import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Theme from '../../theme';
import MobileHeader from './MobileHeader';
import MobileMenu from './MobileMenu';
import DesktopHeader from './DesktopHeader';
var StyledHeader = styled.div.withConfig({
  displayName: "Header__StyledHeader",
  componentId: "sc-1khghcj-0"
})(["display:flex;align-items:center;height:64px;", ";background-color:", " !important;border-top:4px solid ", ";box-shadow:0 2px 5px 0 ", ";z-index:99999;"], Theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  height: 120px;\n  background-color: ", ";\n  "])), function (props) {
  return props.theme === 'dark' ? Theme.colours.darkslate : Theme.colours.white;
}), function (props) {
  return props.theme === 'dark' ? Theme.colours.darkslate : Theme.colours.white;
}, Theme.colours.singtelred, Theme.colours.grey_d6);
var Header = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Header, _PureComponent);
  function Header() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      isHamburgerMenuOpen: false,
      menuHoverKey: -1,
      activeSubMenuItem: -1,
      activeMenuItem: -1,
      isSearchActive: false
    };
    _this.handleDesktopMenuMouseEnter = function (key) {
      _this.setState({
        menuHoverKey: key
      });
    };
    _this.handleDesktopMenuMouseLeave = function () {
      _this.setState({
        menuHoverKey: -1
      });
    };
    _this.handleHamburgerClick = function () {
      _this.setState(function (prevState) {
        return {
          isHamburgerMenuOpen: !prevState.isHamburgerMenuOpen
        };
      });
    };
    _this.handleMobileMenuItemClick = function (menuKey, subKey) {
      _this.setState(function (prevState) {
        return {
          activeMenuItem: menuKey,
          // Allows us to close the "accordion" feel by toggling on and off
          activeSubMenuItem: prevState.activeSubMenuItem !== subKey ? subKey : -1
        };
      });
    };
    _this.handleSearchClick = function () {
      _this.setState(function (prevState) {
        return {
          isSearchActive: !prevState.isSearchActive
        };
      });
    };
    return _this;
  }
  var _proto = Header.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      baseUrl = _this$props.baseUrl,
      logo = _this$props.logo,
      loginUrl = _this$props.loginUrl,
      shoppingCartUrl = _this$props.shoppingCartUrl,
      showHamburger = _this$props.showHamburger,
      menuItems = _this$props.menuItems,
      showSearch = _this$props.showSearch,
      showLoginButton = _this$props.showLoginButton,
      isCheckOutPage = _this$props.isCheckOutPage,
      showShoppingCart = _this$props.showShoppingCart,
      showAvatar = _this$props.showAvatar,
      avatarMenuItems = _this$props.avatarMenuItems,
      firstLevelLinks = _this$props.firstLevelLinks,
      theme = _this$props.theme;
    var _this$state = this.state,
      isHamburgerMenuOpen = _this$state.isHamburgerMenuOpen,
      activeMenuItem = _this$state.activeMenuItem,
      activeSubMenuItem = _this$state.activeSubMenuItem,
      menuHoverKey = _this$state.menuHoverKey,
      isSearchActive = _this$state.isSearchActive;
    var checkOutMenuItems = [{
      item: {
        active: true,
        title: 'Checkout'
      }
    }];
    return /*#__PURE__*/React.createElement(StyledHeader, {
      theme: theme
    }, /*#__PURE__*/React.createElement(MobileHeader, {
      baseUrl: baseUrl,
      loginUrl: loginUrl,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      onHamburgerClick: this.handleHamburgerClick,
      shoppingCartUrl: shoppingCartUrl,
      showHamburger: !isCheckOutPage && showHamburger,
      showLoginButton: !isCheckOutPage && showLoginButton,
      showAvatar: !isCheckOutPage && showAvatar,
      avatarMenuItems: avatarMenuItems,
      showSearch: !isCheckOutPage && showSearch,
      showShoppingCart: !isCheckOutPage && showShoppingCart,
      showVeriSignLogo: isCheckOutPage,
      theme: theme
    }), /*#__PURE__*/React.createElement(DesktopHeader, {
      baseUrl: baseUrl,
      firstLevelLinks: firstLevelLinks,
      isSearchActive: isSearchActive,
      loginUrl: !isCheckOutPage && loginUrl,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      menuHoverKey: menuHoverKey,
      menuItems: isCheckOutPage ? checkOutMenuItems : menuItems,
      onMenuMouseEnter: this.handleDesktopMenuMouseEnter,
      onMenuMouseLeave: this.handleDesktopMenuMouseLeave,
      onSearchClick: this.handleSearchClick,
      showAvatar: !isCheckOutPage && showAvatar,
      avatarMenuItems: avatarMenuItems,
      showLoginButton: !isCheckOutPage && showLoginButton,
      showTopRHSMenuItems: !isCheckOutPage && firstLevelLinks,
      showSearch: !isCheckOutPage && showSearch,
      showShoppingCart: !isCheckOutPage && showShoppingCart,
      showVeriSignLogo: isCheckOutPage,
      shoppingCartUrl: !isCheckOutPage && shoppingCartUrl,
      theme: theme
    }), /*#__PURE__*/React.createElement(MobileMenu, {
      baseUrl: baseUrl,
      activeSubMenuItem: activeSubMenuItem,
      activeMenuItem: activeMenuItem,
      firstLevelLinks: firstLevelLinks,
      isHamburgerMenuOpen: isHamburgerMenuOpen,
      logoAlt: logo.alt,
      logoLink: logo.link,
      logoSrc: logo.src,
      menuItems: menuItems,
      onClose: this.handleHamburgerClick,
      onMenuItemClick: this.handleMobileMenuItemClick,
      theme: theme
    }));
  };
  return Header;
}(PureComponent);
Header.defaultProps = {
  baseUrl: '',
  logo: {
    alt: 'Singtel.com',
    link: '#'
  },
  menuItems: []
};
export default Header;